import UserQ from '@/queries/UserQ'
import type { Query } from '@/client/query'

import TutorCard from './TutorCard'

export default function TutorCardFromQuery({
  user,
  displayName,
  noOfBioLines = 5,
  openExternally = false,
  hideFooter = false,
}: {
  user: Query
  displayName: string | null
  noOfBioLines?: number
  openExternally?: boolean
  hideFooter?: boolean
}): JSX.Element {
  const tutorId = user(UserQ.id) ?? 0
  const username = user(UserQ.username)
  const superHelpfulCount = user`${UserQ.countAllSuperHelpfuls()}`
  const pastSessionCount = user`${UserQ.countPastHostedSessionsIncludingMigrated({
    requireLearnerAttendance: true,
  })}`
  const availableSessions = user`${UserQ.countUpcomingSessionsHostedByUser()}`
  const followCount = user`${UserQ.countFollowers()}`
  const bio = (user(UserQ.bio) ?? '').trim()
  const progressionLevel = user(UserQ.progression_level)
  const avatarUrl = user(UserQ.avatar_url)

  return (
    <TutorCard
      tutorId={tutorId}
      username={username}
      displayName={displayName}
      superHelpfulCount={superHelpfulCount}
      pastSessionCount={pastSessionCount}
      availableSessions={availableSessions}
      followCount={followCount}
      bio={bio}
      progressionLevel={progressionLevel}
      avatarUrl={avatarUrl ?? ''}
      noOfBioLines={noOfBioLines}
      openExternally={openExternally}
      hideFooter={hideFooter}
    />
  )
}
